import { render, staticRenderFns } from "./DefineForm.vue?vue&type=template&id=096aa4b8"
import script from "./DefineForm.vue?vue&type=script&lang=js"
export * from "./DefineForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports